import styled from "@emotion/styled";

import { BaseLink } from "shared/components/common/base-link";
import { fontRobotoCondensed, fontSourceSerif4, theme } from "shared/lib/styles";

import LogoFlag from "./icon-logo-flag.svg";

/* Mobile: the flag straddles the banner's top edge (half above, half inside);
   from tablet up it sits inline at the start of the row. */
export const StyledLogoFlag = styled(LogoFlag)`
  position: absolute;
  inset-block-start: -13.5px;
  inset-inline: 0;

  inline-size: 35px;
  block-size: 27px;
  margin-inline: auto;

  ${theme.breakpoints.up("tablet")} {
    position: static;

    flex-shrink: 0;

    inline-size: 60px;
    block-size: 46px;
    margin-inline: 0;
  }
`;

export const Container = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;

  /* Button's margin-block-end: -17px makes it straddle the bottom border,
     overflowing 15px below (17px - 2px border). Bottom padding is 0 to
     allow straddling; margin-block-end compensates so the grid row
     includes the overflow. Top: 13px strip + 12px inner padding (Figma). */
  margin-block-end: 15px;
  padding-block: 25px 0;
  padding-inline: 20px;

  border: 2px solid #dfdfdf;

  background-color: #f8f8f8;

  ${theme.breakpoints.up("tablet")} {
    flex-direction: row;
    gap: 28px;

    margin-block-end: 0;
    padding-block: 20px;
    padding-inline: 24px;

    border-width: 1px;
  }

  /* Desktop centres the flag + text + button cluster; tablet spreads the text
     between the flag and the button. */
  ${theme.breakpoints.up("desktop")} {
    justify-content: center;
  }
`;

export const Text = styled.div`
  color: #000000;
  font-weight: 400;
  font-size: 20px;
  font-family: ${fontSourceSerif4};
  line-height: normal;
  text-align: center;

  ${theme.breakpoints.up("tablet")} {
    flex: 1 1 0;

    font-weight: 600;
    font-size: 22px;
    line-height: 115%;
    letter-spacing: -0.44px;
    text-align: start;
  }

  ${theme.breakpoints.up("desktop")} {
    flex: 0 0 auto;

    font-weight: 600;
    font-size: 24px;
    line-height: normal;
    letter-spacing: -0.48px;
  }
`;

/* Mobile: the button straddles the banner's bottom edge via negative margin. */
export const SupportButton = styled(BaseLink)`
  inline-size: fit-content;
  margin-block-end: -17px;
  margin-inline: auto;
  padding-block: 8px;
  padding-inline: 12px;

  color: #ffffff;
  font-weight: 700;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  line-height: 100%;
  white-space: nowrap;

  border-radius: 4px;

  background-color: #2c4692;

  ${theme.breakpoints.up("tablet")} {
    flex-shrink: 0;

    margin-block-end: 0;
    margin-inline: 0;
  }
`;
